import lessRequire from '../../../../config/less-require-resolver';
import React from 'react';
import PropTypes from 'prop-types';

import Single from './single';
import Multi from './multi';

lessRequire('modules/shared/filters/suggest.less');

const propTypes = {
	filter: PropTypes.object,
	onInit: PropTypes.func
};

const Suggest = (props) => {
	const RenderComponent = Object.keys(props.filter.suggest).length > 1 ? Multi : Single;
	return <RenderComponent {...props} />;
};

Suggest.propTypes = propTypes;
export default Suggest;


// WEBPACK FOOTER //
// ./frontend/cabinets/modules/shared/filters/suggest/main.js